import {Button, Form, Upload} from "antd";
import styled from "styled-components";
import Utils from "../../../../utils";
import {RcFile} from "antd/es/upload";
import {UploadOutlined} from "@ant-design/icons";
import {useContext, useState} from "react";
import {CatalogContext} from "../../../../providers/CatalogProvider";

const ProductImageItem = () => {
    const {product, setProduct} = useContext(CatalogContext)

    const [image, setImage] = useState<string>(product.image_url || '')

    const props = {
        showUploadList: { showRemoveIcon: false },
        accept: '.png,.svg,.jpeg,.webp'
    }

    const beforeUpload = (file: RcFile) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)

        reader.onload = async () => {
            if (!reader.result || !(typeof reader.result === 'string')) return

            const image_url = await Utils.generateAndUploadThumbnail(file.name, reader.result || '', false)

            setImage(reader.result)

            setProduct({...product, image_url})
        }

        return false
    }

    return (
        <Form.Item label="Image">
            <Upload {...props} beforeUpload={beforeUpload}>
                <Button style={{ width: '100%' }} icon={<UploadOutlined />}>
                    Select Image
                </Button>
            </Upload>
            <StyledPreview preview={image} />
        </Form.Item>
    );
};

export default ProductImageItem;

const StyledPreview = styled.div<{ preview: string }>`
    width: 100px;
    height: 100px;
    background: ${props => `center / contain no-repeat url('${props?.preview}')`};
`
